export function initSearch() {
    // Находим все блоки поиска на странице
    const searchBlocks = document.querySelectorAll('.js-search-block');

    if (searchBlocks) {
        searchBlocks.forEach(block => {
            const searchInput = block.querySelector('input[type="search"]');
            const resultList = block.querySelector('.js-search-result');
            const items = resultList.querySelectorAll('.js-search-item');

            // Слушаем событие ввода текста
            searchInput.addEventListener('input', () => {
                const query = searchInput.value.toLowerCase();

                items.forEach(item => {
                    const text = item.textContent.toLowerCase();
                    if (text.includes(query)) {
                        item.style.display = ''; // Показываем элемент
                    } else {
                        item.style.display = 'none'; // Скрываем элемент
                    }
                });
            });
        });
    }
}
